export var api = {
    baseURL: '/api/v1/',
};
//# sourceMappingURL=default.js.map